import {
    fetchBaseQuery,
    type BaseQueryFn,
    type FetchArgs,
    type FetchBaseQueryError
} from "@reduxjs/toolkit/query";
import { AppStorage } from "../features/storage/appStorage";
import { logout } from "../slices/userSlice";

export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL;

export const getApiBaseUrl = (): string => `${API_BASE_URL}/api/user`;
export const getApiAdminBaseUrl = (): string => `${API_BASE_URL}/api/admin`;

type AuthenticatedBaseQuery = BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
>;

const createBaseQueryWithAuth = (baseUrl: string): AuthenticatedBaseQuery => {
    const baseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: headers => {
            headers.set("Type", "User");

            const token = AppStorage.getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${btoa(token)}`);
            }

            return headers;
        }
    });

    return async (args, api, extraOptions) => {
        const result = await baseQuery(args, api, extraOptions);

        if (result.error?.status === 401) {
            api.dispatch(logout());
        }

        return result;
    };
};

export const baseQueryWithAuth: AuthenticatedBaseQuery = createBaseQueryWithAuth(getApiBaseUrl());
export const baseQueryAdminWithAuth: AuthenticatedBaseQuery = createBaseQueryWithAuth(getApiAdminBaseUrl());
